// 植物資料庫管理器
export const wayspotDatabase = {
  // 預設資料 - 當找不到對應植物時使用
  '科碼門口': {
    zh: {
      title: '植物資訊',
      scientific: 'Scientific Name',
      family: '資料載入中...',
      localName: [],
      taiwanWord: '',
      distribution: '資料載入中...',
      morphology: '資料載入中...',
      description: '正在載入植物詳細資訊，請稍候...'
    },
    en: {
      title: 'Plant Information',
      scientific: 'Scientific Name',
      family: 'Loading...',
      localName: [],
      taiwanWord: '',
      distribution: 'Loading...',
      morphology: 'Loading...',
      description: 'Loading plant details, please wait...'
    }
  },
  '構樹': {
    zh: {
      title: '構樹',
      scientific: 'Broussonetia papyrifera (L.)L\'Herit.ex Vent.',
      family: '桑科',
      localName: [
        { name: 'elraw', location: '南王語' },
        { name: '\'arivun', location: '下賓朗語' }
      ],
      taiwanWord: '鹿仔樹 lo̍k-á-tshiū',
      distribution: '中、低海拔山區至平地及海濱地區。',
      morphology: '半落葉性喬木，樹皮灰褐色，全株具乳汁。葉互生，幼株葉呈深缺刻狀分裂，成株為心狀卵形葉。雌雄異株，雄花長條形，雌花圓球形。聚合果球形，成熟時由綠轉成橘紅色。',
      description: '構樹為陽性先驅樹種。早期鹿農以葉子餵食鹿仔，故又稱為鹿仔樹。成熟的聚合果甜美多汁，能吸引鳥兒及各類昆蟲前來覓食。構樹樹皮纖維細長，是早期原住民用來做樹皮布的最佳材料。'
    },
    en: {
      title: 'Paper Mulberry',
      scientific: 'Broussonetia papyrifera (L.)L\'Herit.ex Vent.',
      family: 'Moraceae(Mulberry Family)',
      localName: [
        { name: 'elraw', location: 'Puyuma' },
        { name: '\'arivun', location: 'Pinaski' }
      ],
      taiwanWord: 'lo̍k-á-tshiū鹿仔樹',
      distribution: 'Mid- to low-elevation mountain areas, plains, and coastal regions.',
      morphology: 'Paper mulberry is a semi-deciduous tree with gray-brown bark and milky sap throughout the plant. Leaves are alternate; seedlings often have deeply lobed leaves, while mature trees bear cordate-ovate leaves. The species is dioecious, with male flowers forming elongate catkins, and female flowers forming globose heads. The spherical aggregate fruits turn from green to bright orange-red when ripe.',
      description: 'Paper mulberry is a sun-loving pioneer species. In the past, its leaves were used by deer farmers as feed for deer, which is why it is also known locally as the “deer tree.” Its ripe aggregate fruits are sweet and juicy, attracting many birds and insects. The tree’s long, strong bark fibers make it one of the best traditional materials used by Indigenous peoples for producing barkcloth.'
    }
  },
  '苦楝': {
    zh: {
      title: '苦楝',
      scientific: 'Melia azedarach Linn.',
      family: '楝科',
      localName: [
        { name: 'gamut', location: '南王語' },
        { name: 'hamut', location: '下賓朗語' }
      ],
      taiwanWord: '苦楝仔 khóo-līng-á',
      distribution: '全島低海拔山麓。',
      morphology: '落葉喬木，嫩枝皮孔密佈。葉為2〜3回奇數羽狀複葉。花淡紫色，具香氣。核果卵狀球形，熟時金黃色至黃褐色。',
      description: '因其木材味苦故又名為「苦楝」，淡紫色花朵於春天盛開並散發特異香氣，是臺灣著名的鄉土植物且具多功能用途，果實是許多野鳥的最愛，種子略具毒性不可誤食。在普悠瑪部落喪家除穢時，巫師會手持苦楝枝條，用手指劃過鼻頭，表示香之意，祈求新的一年帶來好運。苦楝的葉片也是催香蕉的好材料，將葉片舖襯香蕉做後熟處理會讓香蕉特別香甜。'
    },
    en: {
      title: 'Chinaberry',
      scientific: 'Melia azedarach Linn.',
      family: 'Meliaceae (Mahogany Family)',
      localName: [
        { name: 'gamut', location: 'Puyuma dialect' },
        { name: 'hamut', location: 'Pinaski dialect' }
      ],
      taiwanWord: 'khóo-līng-á 苦楝仔',
      distribution: 'Low-elevation foothills throughout Taiwan.',
      morphology: 'A deciduous tree with twigs marked by numerous lenticels. Leaves are bi- to tri-pinnate compound leaves with an odd number of leaflets. Flowers are pale purple and fragrant. The drupes are ovoid to spherical, turning from golden yellow to yellow-brown when ripe.',
      description: 'The wood has a distinctly bitter smell, giving the tree its Chinese name “苦楝” (bitter neem). Its pale purple spring blossoms are known for their unique fragrance, making chinaberry one of Taiwan’s iconic native trees with many uses. The ripe fruits are favored by many bird species, though the seeds are mildly toxic and should not be eaten.\nIn the Puyuma community, chinaberry branches are used in purification rituals: during ceremonies for bereaved families, a traditional practitioner brushes a finger across the nose using a chinaberry twig, symbolizing fragrance and invoking good fortune. Chinaberry leaves are also used to ripen bananas—when layered around the fruit, they enhance its aroma and sweetness.'
    }
  },
  '黃荊': {
    zh: {
      title: '黃荊',
      scientific: 'Vitex negundo L.',
      family: '馬鞭草科',
      localName: [
        { name: 'sangliw', location: '南王語' }
      ],
      distribution: '全島低海拔地區。',
      morphology: '落葉灌木至小喬木，具多數分枝，全株幼嫩部位密生灰白色絨毛。葉對生，掌狀複葉，有長柄，小葉3~7枚，通常為5枚。小花呈淡紫色，果實為核果，成熟實為黑色。',
      description: '黃荊是荒野地常見的先驅植物，在夏秋季節會開紫色小花是良好的蜜源植物。其全株具有香氣，過去普悠瑪部落長輩們常會採集它的葉片搓揉後可驅蚊蟲也可塗抹在身上，具有鎮痛與止癢的功用。此外有時也會使用黃荊的枝葉來驅趕不好的靈，以保護族人。'
    },
    en: {
      title: 'Negundo Chaste Tree',
      scientific: 'Vitex negundo L.',
      family: 'Verbenaceae',
      localName: [
        { name: 'sangliw', location: 'Puyuma dialect' }
      ],
      distribution: 'Low-elevation areas throughout Taiwan. ',
      morphology: 'A deciduous shrub to small tree with many branches. Young stems, leaves, and other tender parts are densely covered with grayish-white hairs. Leaves are opposite, palmately compound with long petioles, bearing 3–7 leaflets, most commonly five. Small flowers are pale purple. The fruit is a drupe that turns black when mature.',
      description: 'Negundo Chaste Tree is a common pioneer species in open or disturbed areas. It produces clusters of small purple flowers in summer and autumn and is an excellent nectar plant for bees. The whole plant is aromatic. In the Puyuma community, elders traditionally collected and rubbed the leaves to repel mosquitoes; the leaf juices could also be applied to the skin for pain relief and itch reduction. Additionally, branches and leaves of sangliw are sometimes used in rituals to ward off harmful spirits and protect community members.'
    }
  },
  '芒果樹': {
    zh: {
      title: '土芒果',
      scientific: 'Mangifera indica L.',
      family: '漆樹科',
      taiwanWord: '檨仔',
      distribution: '原產於印度、中南半島，在臺灣被廣泛栽培為果樹及行道樹。',
      morphology: '葉互生，多叢生於枝條先端，嫩葉帶紫紅色，老葉則呈綠色或暗綠色，長橢圓形，披針形或長披針形，果實為核果狀，於 5月下旬開始成熟，果肉多汁，供食用。',
      description: '土芒果原產於印度、中南半島，臺灣是在荷蘭時期自印尼引進，最早於臺南地區種植。卑南遺址公園過去曾是臨近普悠瑪部落族人的農地，族人常會在農地周邊種植果樹，園區現存有許多芒果樹，品種有土芒果、黑香芒果等，都是過去所栽種留存的果樹。'
    },
    en: {
      title: 'Mango (Local Variety)',
      scientific: 'Mangifera indica L.',
      family: 'Anacardiaceae',
      taiwanWord: 'suāinn-á (檨仔)',
      distribution: 'Native to India and the Indochinese Peninsula; widely cultivated in Taiwan as a fruit tree and as a roadside shade tree.',
      morphology: 'Leaves are alternate and cluster toward the tips of its branches. New leaves are tinged with reddish-purple, while mature leaves are green to dark green. Leaves are long-elliptic, lanceolate, or long-lanceolate. The fruit is a drupe, maturing from late May. The juicy flesh is edible.',
      description: 'This mango variety originates from India and the Indochinese Peninsula. In Taiwan, it was introduced during the Dutch colonial period from Indonesia and was first planted in the Tainan region.\n\The Peinan Archaeological Site Park was once farmland used by nearby Puyuma villagers, who commonly planted fruit trees along field boundaries. Many mango trees survive in the park today—including local mango and Hei Xiang mangoes—remnants of those earlier plantings.'
    }
  },
  '刺竹': {
    zh: {
      title: '刺竹',
      scientific: 'Bambusa stenostachya Hack.',
      family: '禾本科',
      localName: [
        { name: 'miyalligaw', location: '南王語' },
        { name: 'kawayan', location: '下賓朗語' }
      ],
      taiwanWord: '刺竹 tshì-tik',
      distribution: '廣泛栽培於臺灣各地低海拔平地、丘陵地區。',
      morphology: '高大且竹桿密集叢生，其竹桿基部的小枝條如遇缺水會停止生長，先端形成尖刺，是其名稱的由來。',
      description: '刺竹在早期普遍栽植於住家附近，由於其長刺的枝條相互交錯，形成刺網，可做為天然的防禦城牆。刺竹在日常生活中應用得非常廣泛，由於竹肉厚且硬，適合用來搭建房屋，舉凡主樑、橫樑、桁、門、牆等，皆以刺竹為建材，此外竹節亦能作成盛飯、菜、湯的用具，利用中空的莖節鑽洞可變成裝水或酒的容器。'
    },
    en: {
      title: 'Thorny Bamboo',
      scientific: 'Bambusa stenostachya Hack.',
      family: 'Poaceae',
      localName: [
        { name: 'miyalligaw', location: 'Puyuma dialect' },
        { name: 'kawayan', location: 'Pinaski dialect' }
      ],
      taiwanWord: 'tshì-tik (刺竹)',
      distribution: 'Widely cultivated across lowland and hilly areas of Taiwan.',
      morphology: 'A tall bamboo species forming dense clumps. When young side branches at the culm base experience water stress, their growth stops and the tips harden into sharp spines—giving the plant its name “thorny bamboo.”',
      description: 'Thorny bamboo was commonly planted near traditional homes. Its long, interlocking spines form a natural barrier, functioning as a protective “living wall.” It has extensive uses in daily life. Because the culm wall is thick and sturdy, it was widely used as construction material—serving as main posts, beams, rafters, doors, walls, and more. Bamboo internodes can be fashioned into containers for rice, vegetables, or soup; by piercing through the hollow culm sections, they can also be made into vessels for carrying water or wine.'
    }
  },
  '檳榔2': {
    zh: {
      title: '檳榔',
      scientific: 'Areca catechu L.',
      family: '棕櫚科',
      localName: [
        { name: 'puran', location: '' }
      ],
      taiwanWord: '檳榔 pin-nn̂g',
      distribution: '檳榔主要分佈於熱帶，臺灣栽培以中南部較多。',
      morphology: '為園藝作物果樹之常綠喬木，樹幹通直不分枝，高約10-20公尺。葉6-9枚叢生於枝頂，羽狀複葉呈倒三角形。核果卵狀橢圓形，聚集叢生。',
      description: '檳榔的果實添加石灰、荖葉後，為現代人的嗜好食物之一。對於卑南族人而言，從日常的嗜食品、家屋建築、宅地界線、生命禮儀及祭祀等，幾乎脫離不了與檳榔的關係，因此過去族人們大多會在房舍與田地旁種植幾棵檳榔。當檳榔或荖藤缺乏時，便以代用品解饞，例如杜虹花或樟樹的樹皮。此外，檳榔的葉鞘常被製作成容器盛裝食物。'
    },
    en: {
      title: 'Areca Nut (Betel Nut Palm)',
      scientific: 'Areca catechu L.',
      family: 'Arecaceae',
      localName: [
        { name: 'puran', location: '' }
      ],
      taiwanWord: 'pin-nn̂g (檳榔)',
      distribution: 'Primarily distributed in tropical regions; in Taiwan it is widely cultivated, especially in central and southern areas.',
      morphology: 'An evergreen tree cultivated as a horticultural crop. The trunk is straight and unbranched, reaching 10–20 meters in height. Leaves (6–9 in number) cluster at the top of the trunk, forming inverted-triangular, pinnate fronds. The ovoid to elliptic drupes grow in dense clusters.',
      description: 'When combined with slaked lime and betel pepper leaves (Piper betle), the fruit is a widely consumed stimulant in contemporary Taiwan. For the Pinuyumayan, however, the significance of puran extends far beyond chewing—it is deeply embedded in everyday life, house construction, boundary marking of land, life-cycle rituals, and ceremonial practices. For this reason, families traditionally planted betel nut palms around homes and agricultural fields.\nWhen betel nuts or betel pepper vines were unavailable, substitutes such as the bark of Formosan Beautyberry or camphor trees were used to satisfy cravings. Betel palm sheaths were also commonly fashioned into containers for holding or serving food.'
    }
  },
  '棋盤腳': {
    zh: {
      title: '棋盤腳樹',
      scientific: 'Barringtonia asiatica (L.) Kurz.',
      family: '玉蕊科',
      distribution: '恆春半島、蘭嶼、綠島及東部海岸。',
      morphology: '常綠喬木，老樹幹會瘤狀突起。葉互生，叢生枝端，光滑深綠，厚革質。總狀花序頂生，夜間開放具香氣，雄蕊多數。核果4稜偶有5稜形，中果皮富含纖維質，能海漂傳播。'
    },
    en: {
      title: 'Fish Poison Tree',
      scientific: 'Barringtonia asiatica (L.) Kurz.',
      family: 'Lecythidaceae',
      distribution: 'Hengchun Peninsula, Lanyu (Orchid Island), Green Island, and the eastern coast of Taiwan.',
      morphology: 'An evergreen tree whose mature trunk often forms swollen, knobby protrusions. Leaves are alternate, clustered at branch tips, smooth, thick, and dark green with a leathery texture. Inflorescences are terminal racemes; the flowers open at night and are fragrant, with numerous stamens. The fruits are four-angled (occasionally five-angled) drupes with a fibrous mesocarp, allowing them to disperse long distances by sea.'
    }
  },
  '無患子': {
    zh: {
      title: '無患子',
      scientific: 'Sapindus mukorossi Gaertn.',
      family: '無患子科',
      localName: [
        { name: 'dau', location: '南王語' },
        { name: 'da\'u', location: '下賓朗語' },
      ],
      taiwanWord: '黃目子 n̂g-ba̍k-tsí',
      distribution: '全島低海拔闊葉林',
      morphology: '落葉性喬木。偶數羽狀複葉。小花白色。核果球形，成熟時果實皺縮呈茶褐色，內有一黑色種子非常堅硬。'
    },
    en: {
      title: 'Soapberry Tree',
      scientific: 'Sapindus mukorossi Gaertn.',
      family: 'Sapindaceae',
      localName: [
        { name: 'dau', location: 'Puyuma dialect' },
        { name: 'da\'u', location: 'Pinaski dialect' },
      ],
      taiwanWord: 'n̂g-ba̍k-tsí（黃目子）',
      distribution: 'Broadleaf forests at low elevations throughout Taiwan.',
      morphology: 'A deciduous tree with even-pinnate compound leaves. The small flowers are white. The spherical drupes wrinkle and turn tea-brown when ripe, each containing a single, very hard black seed.'
    }
  },
  '台灣欒樹': {
    zh: {
      title: '臺灣欒樹',
      scientific: 'Koelreuteria henryi Dummer.',
      family: '無患子科',
      localName: [
        { name: 'lripate', location: '下賓朗語' },
      ],
      taiwanWord: '苦楝舅 khóo-līng-kū',
      distribution: '全島低海拔闊葉林中。',
      morphology: '落葉性喬木，樹皮呈片狀剝落。葉互生，二回羽狀複葉，嫩葉紅色。花黃色，中心帶紅色。蒴果三瓣呈膨大氣囊狀。種子球形，黑褐色。'
    },
    en: {
      title: 'Taiwan Golden Rain Tree',
      scientific: 'Koelreuteria henryi Dummer.',
      family: 'Sapindaceae',
      localName: [
        { name: 'lripate', location: 'Pinaski dialect' },
      ],
      taiwanWord: 'khóo-līng-kū (苦楝舅)',
      distribution: 'Low-elevation broadleaf forests throughout Taiwan.',
      morphology: 'A deciduous tree with bark that peels off in irregular plates. Leaves are alternate and bipinnate, with young leaflets emerging red. The flowers are yellow with reddish centers. The three-lobed capsules are inflated and papery, resembling small lanterns. Seeds are spherical and dark brown to black.'
    }
  },
  '九芎': {
    zh: {
      title: '九芎',
      scientific: 'Lagerstroemia subcostata Koehne.',
      family: '千屈菜科',
      localName: [
        { name: 'dalines', location: '南王語與下賓朗語' },
      ],
      taiwanWord: '九芎仔 kiú-kiong-á',
      distribution: '全島中、低海拔山區及平地。',
      morphology: '落葉性喬木，樹皮光滑且易剝落。單葉互生，長橢圓形，全緣。小花白色密生。蒴果長橢圓形，成熟開裂，種子小具狹翼。'
    },
    en: {
      title: 'Subcostate Crape Myrtle',
      scientific: 'Lagerstroemia subcostata Koehne.',
      family: 'Lythraceae',
      localName: [
        { name: 'dalines', location: 'Puyuma and Pinaski dialects' },
      ],
      taiwanWord: 'kiú-kiong-á (九芎仔)',
      distribution: 'Mid- to low-elevation mountain areas and lowland regions throughout Taiwan.',
      morphology: 'A deciduous tree with smooth bark that peels easily. Leaves are simple, alternate, and long-elliptic with entire margins. Small white flowers occur in dense clusters. The elongated capsules split open when mature, releasing small seeds with narrow wings.'
    }
  },
  '血桐': {
    zh: {
      title: '血桐',
      scientific: 'Macaranga tanarius (L.)Muell.-Arg.',
      family: '大戟科',
      localName: [
        { name: 'abayan', location: '南王語' },
        { name: 'vaur', location: '下賓朗語' }
      ],
      distribution: '低海拔山麓、平原及海岸林。',
      morphology: '常綠喬木，小枝及葉柄被白粉。葉盾狀互生，叢生枝端。雌雄異株，花苞淡綠色，無花瓣，雄花花序長。蒴果球形，具刺狀毛，被白粉。'
    },
    en: {
      title: 'Elephant’s ear/ Blood tree',
      scientific: 'Macaranga tanarius (L.)Muell.-Arg.',
      family: 'Euphorbiaceae',
      localName: [
        { name: 'abayan', location: 'Puyuma dialect' },
        { name: 'vaur', location: 'Pinaski dialect' }
      ],
      distribution: 'Foothills, plains, and coastal forests at low elevations.',
      morphology: 'An evergreen tree with branchlets and petioles glaucous. Leaves are peltate (shield-shaped), alternate, and clustered toward the branch tips. The species is dioecious. Buds are light green and lack petals; male inflorescences are elongated. The spherical capsules are echinate and coated with whitish powder.'
    }
  },
  '大葉楠': {
    zh: {
      title: '大葉楠',
      scientific: 'Machilus kusanoi Hayata.',
      family: '樟科',
      localName: [
        { name: 'adaway', location: '南王語' },
        { name: '\'azaway', location: '下賓朗語' }
      ],
      taiwanWord: '楠仔 lâm-á',
      distribution: '全島中低海拔區闊葉林中，多生長於溪谷兩側及潮溼的生育環境。',
      morphology: '常綠喬木。單葉互生，芽苞及新葉呈淡紅色，表面平滑具光澤。小花黃綠色。核果球形，熟果紫黑色。'
    },
    en: {
      title: 'Large-leaved Machilus',
      scientific: 'Machilus kusanoi Hayata.',
      family: 'Lauraceae',
      localName: [
        { name: 'adaway', location: 'Puyuma dialect' },
        { name: '\'azaway', location: 'Pinaski dialect' }
      ],
      taiwanWord: 'lâm-á (楠仔) ',
      distribution: 'Mid- to low-elevation broadleaf forests throughout Taiwan, commonly found along valley slopes and in moist habitats.',
      morphology: 'An evergreen tree with simple, alternate leaves. Buds and young leaves emerge in pale red, and the leaves are smooth and glossy. The small flowers are yellowish-green. The spherical drupes ripen to a dark purple-black.'
    }
  },
  '莿桐': {
    zh: {
      title: '大葉楠',
      scientific: 'Machilus kusanoi Hayata.',
      family: '樟科',
      localName: [
        { name: 'adaway', location: '南王語' },
        { name: '\'azaway', location: '下賓朗語' }
      ],
      taiwanWord: '楠仔 lâm-á',
      distribution: '全島中低海拔區闊葉林中，多生長於溪谷兩側及潮溼的生育環境。',
      morphology: '常綠喬木。單葉互生，芽苞及新葉呈淡紅色，表面平滑具光澤。小花黃綠色。核果球形，熟果紫黑色。'
    },
    en: {
      title: 'Large-leaved Machilus',
      scientific: 'Machilus kusanoi Hayata.',
      family: 'Lauraceae',
      localName: [
        { name: 'adaway', location: 'Puyuma dialect' },
        { name: '\'azaway', location: 'Pinaski dialect' }
      ],
      taiwanWord: 'lâm-á (楠仔) ',
      distribution: 'Mid- to low-elevation broadleaf forests throughout Taiwan, commonly found along valley slopes and in moist habitats.',
      morphology: 'An evergreen tree with simple, alternate leaves. Buds and young leaves emerge in pale red, and the leaves are smooth and glossy. The small flowers are yellowish-green. The spherical drupes ripen to a dark purple-black.'
    }
  },
  '白茅': {
    zh: {
      title: '大葉楠',
      scientific: 'Machilus kusanoi Hayata.',
      family: '樟科',
      localName: [
        { name: 'adaway', location: '南王語' },
        { name: '\'azaway', location: '下賓朗語' }
      ],
      taiwanWord: '楠仔 lâm-á',
      distribution: '全島中低海拔區闊葉林中，多生長於溪谷兩側及潮溼的生育環境。',
      morphology: '常綠喬木。單葉互生，芽苞及新葉呈淡紅色，表面平滑具光澤。小花黃綠色。核果球形，熟果紫黑色。'
    },
    en: {
      title: 'Large-leaved Machilus',
      scientific: 'Machilus kusanoi Hayata.',
      family: 'Lauraceae',
      localName: [
        { name: 'adaway', location: 'Puyuma dialect' },
        { name: '\'azaway', location: 'Pinaski dialect' }
      ],
      taiwanWord: 'lâm-á (楠仔) ',
      distribution: 'Mid- to low-elevation broadleaf forests throughout Taiwan, commonly found along valley slopes and in moist habitats.',
      morphology: 'An evergreen tree with simple, alternate leaves. Buds and young leaves emerge in pale red, and the leaves are smooth and glossy. The small flowers are yellowish-green. The spherical drupes ripen to a dark purple-black.'
    }
  },
  '雀榕': {
    zh: {
      title: '雀榕',
      scientific: 'Ficus microcarpa L.',
      family: '桑科',
      localName: [
        { name: 'adaway', location: '南王語' },
        { name: '\'azaway', location: '下賓朗語' }
      ],
      taiwanWord: '雀榕 lâm-á',
      distribution: '全島中低海拔區闊葉林中，多生長於溪谷兩側及潮溼的生育環境。',
      morphology: '常綠喬木。單葉互生，芽苞及新葉呈淡紅色，表面平滑具光澤。小花黃綠色。核果球形，熟果紫黑色。'
    },
    en: {
      title: 'Large-leaved Machilus',
      scientific: 'Machilus kusanoi Hayata.',
      family: 'Lauraceae',
      localName: [
        { name: 'adaway', location: 'Puyuma dialect' },
        { name: '\'azaway', location: 'Pinaski dialect' }
      ],
      taiwanWord: 'lâm-á (楠仔) ',
      distribution: 'Mid- to low-elevation broadleaf forests throughout Taiwan, commonly found along valley slopes and in moist habitats.',
      morphology: 'An evergreen tree with simple, alternate leaves. Buds and young leaves emerge in pale red, and the leaves are smooth and glossy. The small flowers are yellowish-green. The spherical drupes ripen to a dark purple-black.'
    }
  }
}

// 植物資料管理器
export class WayspotDataManager {
  constructor() {
    this.database = wayspotDatabase
  }

  // 獲取植物資料
  getWayspotData(wayspotTitle, language = 'zh') {
    let plantData = this.database[wayspotTitle]

    // 如果找不到對應的植物資料，使用預設資料
    if (!plantData) {
      console.warn('找不到植物資料，使用預設資料:', wayspotTitle)
      plantData = this.database.default
    }

    return plantData[language] || plantData.zh // 預設使用中文
  }

  // 新增植物資料到資料庫
  addWayspotData(wayspotTitle, zhData, enData) {
    this.database[wayspotTitle] = {
      zh: zhData,
      en: enData
    }
  }

  // 獲取所有可用的植物名稱
  getAvailableWayspots() {
    return Object.keys(this.database).filter(key => key !== 'default')
  }

  // 檢查植物是否存在
  hasWayspot(wayspotTitle) {
    return this.database.hasOwnProperty(wayspotTitle) && wayspotTitle !== 'default'
  }
}

// URL point 參數對應到植物資料庫的 key
export const pointKeyMap = {
  VitexNigra: '黃荊',
  Mango: '芒果樹',
  PaperMulberry: '構樹',
  SpinyBamboo: '刺竹',
  Chinaberry: '苦楝',
  Areca: '檳榔2',
  TaiwanFlamegold: '台灣欒樹',
  Barringtoniaasiatica: '棋盤腳',
  TaiwanCrapeMyrtle: '九芎',
  Soapberry: '無患子',
  Parasolleaftree: '血桐',
  LargeLeavedNanmu: '大葉楠',
  Erythrina: '莿桐',
  Saccharum: '白茅',
  Ficus: '雀榕',
}

// 建立單例實例
export const wayspotDataManager = new WayspotDataManager()